import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const _f4691eac = () => import('../pages/about.vue' /* webpackChunkName: "pages/about" */).then(m => m.default || m)
const _7abe2973 = () => import('../pages/confirm-registration-page.vue' /* webpackChunkName: "pages/confirm-registration-page" */).then(m => m.default || m)
const _b467de76 = () => import('../pages/jury.vue' /* webpackChunkName: "pages/jury" */).then(m => m.default || m)
const _d2f4d22c = () => import('../pages/previous.vue' /* webpackChunkName: "pages/previous" */).then(m => m.default || m)
const _248d5396 = () => import('../pages/request-form.vue' /* webpackChunkName: "pages/request-form" */).then(m => m.default || m)
const _3534ffe0 = () => import('../pages/reset-password-page.vue' /* webpackChunkName: "pages/reset-password-page" */).then(m => m.default || m)
const _4f8109a4 = () => import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */).then(m => m.default || m)
const _c7ca3984 = () => import('../pages/user.vue' /* webpackChunkName: "pages/user" */).then(m => m.default || m)
const _b4f96922 = () => import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(m => m.default || m)
const _48488a42 = () => import('../pages/-participants-page.vue' /* webpackChunkName: "" */).then(m => m.default || m)
const _61d767d9 = () => import('../pages/-participant.vue' /* webpackChunkName: "" */).then(m => m.default || m)
const _3c1a63ac = () => import('../layouts/error.vue' /* webpackChunkName: "" */).then(m => m.default || m)



const scrollBehavior = function(to, from, savedPosition) {
      if (to.path === '/participants-page' && savedPosition) {
        return savedPosition
      } else {
        return {
          x: 0,
          y: 0
        }
      }
    }


export function createRouter () {
  return new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [
		{
			path: "/about",
			component: _f4691eac,
			name: "about"
		},
		{
			path: "/confirm-registration-page",
			component: _7abe2973,
			name: "confirm-registration-page"
		},
		{
			path: "/jury",
			component: _b467de76,
			name: "jury"
		},
		{
			path: "/previous",
			component: _d2f4d22c,
			name: "previous"
		},
		{
			path: "/request-form",
			component: _248d5396,
			name: "request-form"
		},
		{
			path: "/reset-password-page",
			component: _3534ffe0,
			name: "reset-password-page"
		},
		{
			path: "/terms",
			component: _4f8109a4,
			name: "terms"
		},
		{
			path: "/user",
			component: _c7ca3984,
			name: "user"
		},
		{
			path: "/",
			component: _b4f96922,
			name: "index"
		},
		{
			path: "/participants-page",
			component: _48488a42
		},
		{
			path: "/participants-page/:id",
			component: _61d767d9
		},
		{
			path: "*",
			component: _3c1a63ac
		}
    ],
    
    
    fallback: false
  })
}



// WEBPACK FOOTER //
// ./.nuxt/router.js